import { MED_PATIENT_BACKGROUND_SUMMARY_FIELD_KEYS } from "@/types/medchron";
import {
  MED_SUMMARY_CLINICAL_HIGHLIGHT_FIELD_KEYS,
  type MedSummaryDraftFields,
} from "@/types/summary";

import type { BackgroundDraft } from "../types";

/**
 * Lowercase tokens (after trim) treated as no real content for chronology summary free-text fields in view mode.
 */
export const SUMMARY_TAB_TEXT_EMPTY_PLACEHOLDER_TOKENS: ReadonlySet<string> = new Set([
  "unknown",
  "n/a",
  "na",
  "none",
]);

export function isSummaryTabTextEmptyForDisplay(value: string | null | undefined): boolean {
  if (value == null) return true;
  const trimmed = value.trim();
  if (!trimmed) return true;
  if (trimmed === "-" || trimmed === "—" || trimmed === "–") return true;
  return SUMMARY_TAB_TEXT_EMPTY_PLACEHOLDER_TOKENS.has(trimmed.toLowerCase());
}

export function hasAnyNonEmptySummaryTabTextFields(
  record: Partial<Record<string, string | null | undefined>>,
  fieldKeys: readonly string[]
): boolean {
  return fieldKeys.some((key) => !isSummaryTabTextEmptyForDisplay(record[key]));
}

export function hasAnyPatientBackgroundDisplayContent(draft: BackgroundDraft): boolean {
  return hasAnyNonEmptySummaryTabTextFields(draft, MED_PATIENT_BACKGROUND_SUMMARY_FIELD_KEYS);
}

export function hasAnyClinicalHighlightsDisplayContent(draft: MedSummaryDraftFields): boolean {
  return hasAnyNonEmptySummaryTabTextFields(draft, MED_SUMMARY_CLINICAL_HIGHLIGHT_FIELD_KEYS);
}
